export {
  clearFirebase,
  deleteRefusedNewAccount,
  getAuthenticationToken,
  initializeAuthenticationService,
  isMaybeFirebaseError,
  hasUnverifiedSignedInUser,
  isSignInWithEmailLink,
  lookUpEnterpriseSsoProviderTypes,
  onAuthenticationStateChange,
  readEmailLinkInternalErrorReason,
  readProvisioningErrorReason,
  refreshFirebaseIdToken,
  signInWithCustomToken,
  signInWithEmailAndPassword,
  signInWithEmailLink,
  startOAuth,
  migrateSsoUser,
  EMAIL_NOT_VERIFIED_REJECTION_REASON,
  NO_PROVIDER_EMAIL_ERROR,
  SERVICE_BUSY_ERROR,
} from './firebase.utils';
export type { AuthenticationUser } from './firebase.types';
export { SsoProvider } from './sso-provider.enum';
export type { EnterpriseSsoProvider } from './sso-provider.enum';
